<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3337 14V12.6667C11.3337 11.9594 11.0527 11.2811 10.5526 10.781C10.0525 10.281 9.37424 10 8.66699 10H3.33366C2.62641 10 1.94814 10.281 1.44804 10.781C0.947944 11.2811 0.666992 11.9594 0.666992 12.6667V14M15.3337 14V12.6667C15.3332 12.0758 15.1366 11.5018 14.7746 11.0349C14.4126 10.5679 13.9057 10.2344 13.3337 10.0867M10.667 2.08667C11.2406 2.23353 11.749 2.56713 12.1121 3.03487C12.4752 3.50261 12.6722 4.07789 12.6722 4.67C12.6722 5.26211 12.4752 5.83739 12.1121 6.30513C11.749 6.77287 11.2406 7.10647 10.667 7.25333M8.66699 4.66667C8.66699 6.13943 7.47309 7.33333 6.00033 7.33333C4.52757 7.33333 3.33366 6.13943 3.33366 4.66667C3.33366 3.19391 4.52757 2 6.00033 2C7.47309 2 8.66699 3.19391 8.66699 4.66667Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
